import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';
import { BackToHome } from '../BackToHome';
import { ButtonWithContentWrapper } from '../ButtonWithContentWrapper';
import { ReferenceCardWrapper } from '../ReferenceCardWrapper';
import { ArticleReferenceCardWrapper } from '../ArticleReferenceCardWrapper';
import standardiseContentfulId from '../../util/standardiseContentfulId';

const propTypes = {
  brand: PropTypes.string,
  data: PropTypes.object,
  backButton: PropTypes.boolean,
};

const defaultProps = {
  brand: 'law',
  data: {},
  backButton: false,
};

const ReferenceCardSection = ({ brand, data, backButton }) => {
  const { contentfulId, title: heading, hasBackground, referenceCards } = data;
  const backgroundStyling = hasBackground ? 'bg-shadow' : '';

  const renderCardType = (refCard) => {
    const cardType = refCard?.__typename;

    switch (cardType) {
      case 'ContentfulButtonWithContent': {
        return (
          <ButtonWithContentWrapper
            brand={brand}
            data={{ ...refCard, hasShadow: false, card: true }}
          />
        );
      }
      case 'ContentfulReferenceCard': {
        return <ReferenceCardWrapper brand={brand} card={refCard} />;
      }
      case 'ContentfulArticlePage': {
        return <ArticleReferenceCardWrapper article={refCard} brand={brand}/>;
      }
      default: {
        return null;
      }
    }
  };

  return (
    <section
      data-testid="reference-card-section"
      className={`${brand} ${backgroundStyling} reference-card-section`}
      id={standardiseContentfulId(contentfulId)}
    >
      <Container className={`pt-5 pb-5 ${brand}`}>
        {heading && (
          <Row
            data-testid="reference-card-section-heading"
            className="mx-0 mb-5"
          >
            <Col className="p-0 reference-card-section-heading">
              <h2>{heading}</h2>
              {backButton && <BackToHome brand={brand} />}
            </Col>
          </Row>
        )}
        <Row className="ml-md-0">
          {referenceCards && referenceCards.map((card, index) => (
            <Col className="pb-4 pl-md-0 reference-card-item" xs={12} md={6} key={index}>
              {renderCardType(card)}
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

ReferenceCardSection.propTypes = propTypes;
ReferenceCardSection.defaultProps = defaultProps;

export { ReferenceCardSection };
